import React from 'react';
import {connect} from 'react-redux';
import Modal from '../ui/Modal';
import BlueButton from '../buttons/BlueButton';
import Translate from '../../components/Translate';
import CircleAlertIcon from '../../assets/icons/CircleAlertIcon';
import {generalModalStyles} from '../../utils/General';
import {DISMISS_CHAT_SOUND_WARNING} from '../../services/notification/soundWarning';

const ChatSoundWarning = ({isOpen, dismiss}) => (
    <Modal
        isOpen={isOpen}
        onRequestClose={dismiss}
        title={<Translate text="chatSoundBlockedTitle"/>}
        contentLabel="New chat sound blocked"
        headerIcon={<CircleAlertIcon size={24} stroke="var(--ds-warning-primary)"/>}
        style={{
            ...generalModalStyles.confirmModalStyles,
            content: {...generalModalStyles.confirmModalStyles.content, width: '440px'},
        }}
        footer={<BlueButton type="button" height="40px" onClick={dismiss}>
            <Translate text="chatSoundBlockedAcknowledge"/>
        </BlueButton>}
    >
        <Translate text="chatSoundBlockedMessage"/>
    </Modal>
);

export default connect(
    state => ({isOpen: state.soundWarning}),
    dispatch => ({dismiss: () => dispatch({type: DISMISS_CHAT_SOUND_WARNING})}),
)(ChatSoundWarning);



// WEBPACK FOOTER //
// ./src/components-new/general/ChatSoundWarning.jsx